import { combineEpics } from 'redux-observable';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/filter';
import 'rxjs/add/observable/of';
import { isInMentionsIndicatorExperimentCohort } from '@atlassian/jira-mentions-indicator';
import { type MentionsLoadAction, mentionsLoad } from '../../state/actions/issue/mentions';
import {
	WORK_DATA_SET,
	type WorkDataSetAction,
	showMissingIssueTypeMessage,
} from '../../state/actions/work';
import { getIsCMPBoard } from '../../state/selectors/software/software-selectors';
import type { Action, State, ActionsObservable, MiddlewareAPI } from '../../state/types';

const showMissingIssueTypeMessageEpic = (action$: ActionsObservable, store: MiddlewareAPI) =>
	action$
		.ofType(WORK_DATA_SET)
		.filter(
			({ payload }: WorkDataSetAction) =>
				getIsCMPBoard(store.getState()) && !!payload?.missingIssueType,
		)
		.switchMap(({ payload }: WorkDataSetAction) =>
			Observable.of(showMissingIssueTypeMessage(`${payload.missingIssueType}`)),
		);

const loadMentionsAfterWorkDataEpic = (
	action$: ActionsObservable,
): Observable<MentionsLoadAction> =>
	action$.ofType(WORK_DATA_SET).switchMap(({ payload }: WorkDataSetAction) => {
		if (isInMentionsIndicatorExperimentCohort()) {
			const issueIds = payload.issues.map((issue) => issue.id);
			const issueChildrenIds = payload.issueChildren.map((issue) => issue.id);
			return Observable.of(mentionsLoad([...issueIds, ...issueChildrenIds]));
		}

		return Observable.of();
	});

export default combineEpics<Action, State>(
	showMissingIssueTypeMessageEpic,
	loadMentionsAfterWorkDataEpic,
);
